type ListerCallback<T> = (...args: T[]) => void;
export default class Emitter<T> {
  private events = new Map<string, Array<ListerCallback<T>>>();

  on(type: string, listener: ListerCallback<T>) {
    this.events.set(type, this.events.get(type) || []);
    const listeners = this.events.get(type);
    listeners?.push(listener);
  }

  emit(type: string, ...args: T[]) {
    const listeners = this.events.get(type);
    if (listeners) {
      listeners.forEach((listener: ListerCallback<T>) => {
        listener(...args);
      });
    }
  }

  off(type: string, listener: ListerCallback<T>) {
    const listeners = this.events.get(type);
    if (listeners) {
      const index = listeners.indexOf(listener);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }
}
